// extracted by mini-css-extract-plugin
module.exports = {"table-row":"ldapDepartment__table-row","checkbox":"ldapDepartment__checkbox"};